export enum MaintenanceStatus {
  OK = 'OK',
  MISSING_DATA = 'Missing Data',
  BATTERY_WARNING = 'Battery Warning',
  SCAN_ENGINE_WARNING = 'Scan Engine Warning',
  SOFTWARE_WARNING = 'Software Warning',
  CUSTOM_FIRMWARE = 'Custom Firmware',
  MULTIPLE_WARNINGS = 'Multiple Warnings',
}
